import gql from "graphql-tag";

export const getContabilidadPropietarioListGql = gql`
    query data {
        contabilidadPropietarioList{
            idContabilidad
            idPropietarioContabilidad
        }
    }
`;

export const getDatosContabilidadPropietarioGql = gql`
    query data ($idCuenta: String!) {
        datosClienteProp(idCuenta:$idCuenta){
            codigoCliente
            denominacionCliente
            email
            idSuscripcion
            tipoDoc
            serieDoc
            nroDoc
            fechaEmision
            fechaExpiracion
            almacenamiento
            idPlan
            denominacionPlan
            recurrencia
        }
    }
`;
